import * as React from 'react';
import { hasContent } from "./hasContent";
var H1Text = function (_a) {
  var text = _a.text;
  if (!text || !hasContent(text)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "webmasterSeo",
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
};
export default H1Text;